import React, {useContext} from 'react';
import {QuestionsContext} from '../context/questions';
import Question from './question';
import Link from './link';
import Loan from './loans';
import InitialQuestion from './initialQuestion';


    

const Questionnaire = ({data}) => {
    const {list} = useContext(QuestionsContext);

    return <div>
        {list.map( (item, index) => 
            index === 0 ?
            <InitialQuestion 
                item={item} 
                isActive={list.indexOf(item) + 1 === list.length}
            />
            :
              item.type === "question" ?
                <Question 
                    item={item} 
                    isActive={list.indexOf(item) + 1 === list.length}
                />
              :

                item.type === "question_link_action" ?
                    <Link 
                        item={item} 
                        isActive={list.indexOf(item) + 1 === list.length}
                    />
                    :
                    <Loan 
                        item={item} 
                        isActive={list.indexOf(item) + 1 === list.length}
                    />

        )} 
    </div>
}

export default Questionnaire;